import { ReactNode } from 'react';

import { chakra, Flex, VStack } from 'components/uikit';

interface PaymentLayoutProps {
  children: ReactNode;
  headerElement?: ReactNode;
}

export function PaymentLayout({ children, headerElement }: PaymentLayoutProps) {
  return (
    <Flex w='100%' h='100%'>
      <chakra.main flex={1} overflowY='auto' bg='grey.background'>
        <VStack
          position='fixed'
          w='100%'
          align={['center', 'start']}
          py='16px'
          px='32px'
          gap='16px'
        >
          {headerElement}
        </VStack>
        <VStack h='100%' justify='center'>
          {children}
        </VStack>
      </chakra.main>
    </Flex>
  );
}
